export default __webpack_public_path__ + "static/media/woocommerce-dark.42278612.svg";